<template>
  <button
    ref="rsButton"
    type="button"
    class="rs-button"
    :class="[`rs-button--${variant}`, loading ? 'rs-button--loading' : '']"
    @click="click"
    :disabled="disabled"
  >
    <slot v-if="!loading">Some text</slot>
    <span v-else class="rs-button__loader"><loading-icon :size="28" title="Loading" /></span>
  </button>
</template>

<script>
  import LoadingIcon from './RsLoadingIcon'

  export default {
    name: 'RsButton',

    components: { LoadingIcon },

    props: {
      variant: {
        type: String,
        default: 'default'
      },
      loading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      click() {
        this.$emit('button:click')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .rs-button {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 5px 25px;
    min-height: 40px;
    border-radius: 3px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    text-decoration: none;
    transition: 0.2s all ease;
    border: none;
    cursor: pointer;
    text-align: center;
    box-sizing: border-box;

    &:disabled,
    &:disabled:hover {
      cursor: not-allowed;
      background: rgba(0, 0, 0, 0.1);
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
      color: rgba(0, 0, 0, 0.5);
    }

    &:focus {
      box-shadow: none;
      outline: none;
    }

    &--loading {
      .rs-button {
        &__loader {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -14px;
          margin-top: -14px;
          animation: rotate 1s linear infinite;
        }
      }
    }

    &--default {
      background-color: #fff;
      color: #606060;

      &:hover,
      &:focus {
        color: #606060;
        background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%);
      }
    }

    &--primary {
      background-color: var(--rs-accent-color);
      color: #fff;

      &:hover,
      &:focus {
        color: #fff;
        background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%);
      }
    }

    &--danger {
      background-color: var(--rs-danger-color);
      color: #fff;

      &:hover,
      &:focus {
        color: #fff;
        background-image: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%);
      }
    }
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
